export default __webpack_public_path__ + "static/media/1929.b528d7f0.png";